// header-store.ts

import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

interface THeaderState {
	headerActionButtonText: string;
	setHeaderActionButtonText: (headerActionButtonText: string) => void;
	headerActionButtonLocation: string;
	setHeaderActionButtonLocation: (headerActionButtonLocation: string) => void;
	reset: () => void;
}

export const useHeaderStore = create<THeaderState>()(
	subscribeWithSelector((set) => ({
		headerActionButtonText: 'Painel',
		setHeaderActionButtonText: (headerActionButtonText: string) => {
			set(() => ({
				headerActionButtonText,
			}));
		},
		headerActionButtonLocation: '/painel',
		setHeaderActionButtonLocation: (headerActionButtonLocation: string) => {
			set(() => ({
				headerActionButtonLocation,
			}));
		},
		reset: () => set(() => ({})),
	})),
);
